import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconApprovalThick({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M8 13H4a1 1 0 0 1-1-1V8a5 5 0 1 1 5 5zM2 8a6 6 0 1 1 6 6H4a2 2 0 0 1-2-2V8zm8.623-1.418a.5.5 0 0 0-.746-.664l-2.742 3.08-1.012-1.136a.5.5 0 1 0-.746.665l1.384 1.555a.5.5 0 0 0 .747 0l3.115-3.5z"/>
        </svg>
    );
}

export default IconApprovalThick;

